import React from 'react'


import '../../../styles/About/Route/Graduation.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons'

const Graduation = () => {
    return (
        <>
            <div className="graduation">
                <div className="graduation__container">
                    <div className="graduation__header">
                        <h2 className="graduation__number">0<span>4</span></h2>
                        <h1 data-aos='fade-down' data-aos-offset="0">E<span>ducation</span>.</h1>
                    </div>

                    <div className="graduation__description">
                        <h1>Career Point University, Kota</h1>
                        <h2><FontAwesomeIcon icon={faCalendarDays} className="internships__calendar" />&nbsp;&nbsp;01/08/2022 - 31/07/2025</h2>
                        <p>I am currently pursuing a Bachelor's degree in Computer Application with specialization in Data Science at Career Point University, Kota. I have completed 4 semesters and have a CGPA of 9.5.</p><br/><br/>

                        <h1>School Of Excellence, Khichripur</h1>
                        <h2><FontAwesomeIcon icon={faCalendarDays} className="internships__calendar" />&nbsp;&nbsp;01/07/2020 - 31/05/2022</h2>
                        <p>I completed my class 12 high school education at School Of Excellence, Khichripur, where I studied Science with math</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Graduation